import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
// import SEO from '../components/SEO';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#081428] text-[#EAEAEA]">
      {/* <SEO
        title="Política de Privacidade"
        description="Política de Privacidade e Comunicações da LawX. Saiba como coletamos, usamos e protegemos suas informações pessoais em conformidade com a LGPD."
        keywords="política de privacidade, privacidade, LGPD, proteção de dados, Mailchimp"
        url="/privacy"
      /> */}
      <Navbar />
      <main className="container mx-auto px-8 md:px-32 lg:px-48 xl:px-64 pt-24 pb-12">
        <h1 className="text-4xl font-bold mb-4">Política de Privacidade e Comunicações da LawX</h1>
        <p className="text-gray-400 mb-8 italic">Última atualização: [preencher data]</p>
        
        <p className="mb-8 text-gray-300">
          A LawX N3W DIGITAL LTDA, 30.750.260/0001-45, com sede em R CAMPOLINO ALVES, 300, ABRAAO, FLORIANÓPOLIS, é uma empresa voltada para inteligência artificial aplicada ao setor jurídico. Esta Política explica como coletamos, usamos, armazenamos e compartilhamos dados pessoais, inclusive em ações de marketing por e-mail, em conformidade com a LGPD e com boas práticas de plataformas de disparo como o Mailchimp.
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Quem controla os dados</h2>
          <p className="text-gray-300">
            A LawX atua como controladora dos dados pessoais coletados em seus canais (site, landing pages, formulários, eventos e contato direto). Em determinadas operações, utilizamos fornecedores que atuam como operadores, incluindo o Mailchimp para gestão de listas e envio de comunicações.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Dados que podemos coletar</h2>
          <p className="text-gray-300 mb-3">Podemos coletar:</p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
            <li><strong>Dados de identificação e contato:</strong> nome, e-mail, telefone, empresa, cargo, área de atuação.</li>
            <li><strong>Dados de uso e navegação:</strong> páginas acessadas, IP, dispositivo, logs e métricas de interação.</li>
            <li><strong>Preferências de comunicação:</strong> interesses, áreas jurídicas, temas de conteúdo.</li>
            <li><strong>Dados fornecidos voluntariamente:</strong> mensagens enviadas por você em formulários, chats ou suporte.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Finalidades de uso</h2>
          <p className="text-gray-300 mb-3">Usamos seus dados para:</p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
            <li>Fornecer e aprimorar os serviços e funcionalidades da LawX.</li>
            <li>Atender solicitações, suporte e relacionamento.</li>
            <li>Personalizar sua experiência de navegação e conteúdo.</li>
            <li>Enviar comunicações institucionais, educativas e promocionais quando houver base legal adequada, especialmente consentimento.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Comunicações por e-mail (regras de permissão)</h2>
          <p className="text-gray-300 mb-3">
            A LawX adota um modelo de comunicação baseado em permissão. Isso significa que:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
            <li>Somente enviamos e-mails de marketing para contatos que tenham fornecido consentimento válido por meio de nossos formulários ou outra base legítima permitida pela lei aplicável.</li>
            <li>Não utilizamos listas compradas, alugadas, de terceiros, co-registro ou bases públicas para envio de campanhas.</li>
            <li>Mantemos registros de opt-in (ex.: data, origem do cadastro e formulário) para comprovar permissão quando necessário.</li>
            <li>Nossos e-mails de marketing incluem mecanismo de descadastro funcional, preferencialmente o próprio mecanismo do Mailchimp.</li>
            <li>Caso você esteja há muito tempo sem interagir, podemos solicitar reconfirmação de interesse antes de retomar envios regulares.</li>
          </ul>
          <p className="text-gray-300 mt-4 italic">
            Observação: Comunicações estritamente transacionais ou de serviço (ex.: avisos relevantes sobre conta, segurança, mudanças do produto) podem ser enviadas quando necessárias, respeitando a legislação aplicável.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Cookies e tecnologias similares</h2>
          <p className="text-gray-300 mb-3">Utilizamos cookies e tecnologias semelhantes para:</p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
            <li>Lembrar preferências,</li>
            <li>Medir desempenho do site e campanhas,</li>
            <li>Melhorar funcionalidades.</li>
          </ul>
          <p className="text-gray-300 mt-4">
            Você pode gerenciar cookies pelo seu navegador. Dependendo da configuração de ferramentas de terceiros integradas, pode ser necessário consentimento adicional conforme regras aplicáveis.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Compartilhamento de dados</h2>
          <p className="text-gray-300 mb-3">Podemos compartilhar dados com:</p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
            <li>Fornecedores de tecnologia essenciais para operação do serviço (ex.: hospedagem, analytics, CRM e plataformas de e-mail).</li>
            <li>Mailchimp, para gestão de audiência, automações e disparo de comunicações autorizadas.</li>
          </ul>
          <p className="text-gray-300 mt-4 font-semibold">
            Não vendemos seus dados pessoais.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Transferência internacional</h2>
          <p className="text-gray-300">
            O Mailchimp possui servidores localizados nos Estados Unidos. Assim, ao usar nossos formulários e aceitar comunicações, seus dados podem ser transferidos, armazenados ou processados nos EUA, com salvaguardas contratuais e medidas de proteção indicadas pelo próprio fornecedor e pela legislação aplicável.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. Segurança da informação</h2>
          <p className="text-gray-300">
            Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda, alteração ou divulgação indevida. Também selecionamos fornecedores que mantenham padrões adequados de segurança.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">9. Retenção</h2>
          <p className="text-gray-300 mb-3">Mantemos seus dados pelo tempo necessário para:</p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
            <li>Cumprir as finalidades descritas nesta Política,</li>
            <li>Atender obrigações legais e regulatórias,</li>
            <li>Resguardar direitos da LawX.</li>
          </ul>
          <p className="text-gray-300 mt-4">
            Você pode solicitar exclusão quando aplicável.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">10. Direitos do titular (LGPD)</h2>
          <p className="text-gray-300 mb-3">Você pode solicitar, a qualquer momento:</p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
            <li>Confirmação de tratamento,</li>
            <li>Acesso,</li>
            <li>Correção,</li>
            <li>Anonimização, bloqueio ou exclusão,</li>
            <li>Portabilidade,</li>
            <li>Informação sobre compartilhamentos,</li>
            <li>Revogação do consentimento.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">11. Alterações desta Política</h2>
          <p className="text-gray-300">
            Podemos atualizar esta Política periodicamente. Quando houver mudanças relevantes, informaremos por nossos canais oficiais.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">12. Contato</h2>
          <p className="text-gray-300">
            Em caso de dúvidas ou solicitações sobre privacidade:
          </p>
          <p className="text-gray-300 mt-2">
            <strong>E-mail:</strong> <a href="mailto:contato@lawx.ai" className="text-blue-400 hover:text-blue-300 underline">contato@lawx.ai</a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
